// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PwzA","question":"styles_question__2wMA2","inputVisibleButton":"styles_inputVisibleButton__1kuUM","note":"styles_note__TtTir"};